import { render, staticRenderFns } from "./reset_password.vue?vue&type=template&id=2213f573&scoped=true&"
import script from "./reset_password.vue?vue&type=script&lang=js&"
export * from "./reset_password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2213f573",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2213f573')) {
      api.createRecord('2213f573', component.options)
    } else {
      api.reload('2213f573', component.options)
    }
    module.hot.accept("./reset_password.vue?vue&type=template&id=2213f573&scoped=true&", function () {
      api.rerender('2213f573', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/captains/actions/reset_password.vue"
export default component.exports